"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfHighlightUrlDto = instanceOfHighlightUrlDto;
exports.HighlightUrlDtoFromJSON = HighlightUrlDtoFromJSON;
exports.HighlightUrlDtoFromJSONTyped = HighlightUrlDtoFromJSONTyped;
exports.HighlightUrlDtoToJSON = HighlightUrlDtoToJSON;
exports.HighlightUrlDtoToJSONTyped = HighlightUrlDtoToJSONTyped;
/**
 * Check if a given object implements the HighlightUrlDto interface.
 */
function instanceOfHighlightUrlDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function HighlightUrlDtoFromJSON(json) {
    return HighlightUrlDtoFromJSONTyped(json, false);
}
function HighlightUrlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
    };
}
function HighlightUrlDtoToJSON(json) {
    return HighlightUrlDtoToJSONTyped(json, false);
}
function HighlightUrlDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
    };
}
